// extracted by css-extract-rspack-plugin
export default {"wrapper":"WizardHeader_wrapper__VLUjM","buttonsWrapper":"WizardHeader_buttonsWrapper__B0bLK"};